export const accessSelectorKey = "access-security-model-editor";
